import { api } from "../api";

export const UploadService = {
    upload: async (token, { nomTab, seqTab1, seqTab2, seqTab3 = 0, pasta = null, contentType = 'application/pdf' }, file) => {
        let url = `/upload?nomtab=${nomTab}&seqtab1=${seqTab1}&seqtab2=${seqTab2}`;

        if (seqTab3 > 0) {
            url += `&seqtab3=${seqTab3}`;
        }

        if (pasta != null) {
            url += `&pasta=${pasta}`
        }

        const response = await api.post(url, file, {
            headers: {
                "Authorization": `${token}`,
                "Content-Type": contentType
            }
        });

        return response.data;
    },
    download: async (token, { codope, nomTab, seqTab1, seqTab2, seqTab3 = 0, pasta = null, contentType = 'application/json', responseType = 'blob' }) => {
        let url = `/download?codope=${codope}&nomtab=${nomTab}&seqtab1=${seqTab1}&seqtab2=${seqTab2}`;

        if (seqTab3 > 0) {
            url += `&seqtab3=${seqTab3}`;
        }

        if (pasta != null) {
            url += `&pasta=${pasta}`
        }

        const response = await api.get(url, {
            headers: {
                "Authorization": `${token}`,
                "Content-Type": contentType,
                "Accept": "*/*",
            },
            responseType: responseType
        });

        return response.data;
    }
}